<div class="page-layout carded left-sidenav toolbar-fixed-layout"> <!-- fusePerfectScrollbar -->

  <!-- HEADER -->
  <!--<div class="toolbar second-level-toolbar" fxLayoutAlign="space-between center">
    <div fxLayout="column" fxLayoutAlign="center start" class="grid-toolbar-buttons-group-container w-p-100">
      <particle-breadcrumbs [breadcrumbs]="breadcrumbs" [iconClass]="'fas fa-briefcase'"></particle-breadcrumbs>
    </div>
  </div>-->

  <mat-sidenav-container *ngIf="countryDictionary">
    <div class="center">
      <div class="content-card mat-white-bg">
        <div class="scroll">
          <div class="content pos-relative p-b-30 flex flex-col">
            <table class="table-border">
              <tr *ngFor="let row of memoInfo?.spreadsheet?.rows">
                <td *ngFor="let cell of row?.cells" [colSpan]="cell.colSpan" class="{{cell.style}}">
                  <mat-form-field class="w-p-100" *ngIf="cell.style === 'InputOptionCell'"
                                  appearance="outline">
                    <mat-select [(ngModel)]="cell.value" (selectionChange)="onMemoValueChange($event, cell)">
                      <mat-option *ngFor="let option of cell.options" [value]="option">{{option}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="w-p-100" *ngIf="cell.style === 'CountryCell'"
                                  appearance="outline">
                    <mat-select [(ngModel)]="cell.value" (selectionChange)="onMemoValueChange($event, cell)"
                                panelClass="country-cell">
                      <mat-select-trigger>
                        <div class="flex flex-row justify-between items-center">
                          {{cell.value}}
                          <div class="flex flex-row justify-start items-center">
                            <div
                              *ngIf="countryDictionary[cell.value]?.actualCount>0 || countryDictionary[cell.value]?.proposedCount>0"
                              class="actual-enitiy flex flex-row justify-start items-center m-r-15"
                              matTooltip="{{countryDictionary[cell.value]?.actualCount > 0 ? countryDictionary[cell.value]?.actualCount + (countryDictionary[cell.value]?.actualCount > 1 ? ' Actual Entities' : ' Actual Entity') : ''}} {{countryDictionary[cell.value]?.actualCount>0 && countryDictionary[cell.value]?.proposedCount>0 ? '& ' : ''}}{{countryDictionary[cell.value]?.proposedCount > 0 ? countryDictionary[cell.value]?.proposedCount + (countryDictionary[cell.value]?.proposedCount > 1 ? ' Proposed Entities' : ' Proposed Entity') : ''}}"
                            >
                              <i class="far fa-stop m-r-5"></i>
                              <span>{{countryDictionary[cell.value]?.actualCount + countryDictionary[cell.value]?.proposedCount}}</span>
                            </div>
                            <div
                              *ngIf="countryDictionary[cell.value]?.transactionCount>0"
                              class="actual-enitiy m-r-15 flex flex-row justify-start items-center"
                              matTooltip="{{countryDictionary[cell.value]?.transactionCount > 0 ? countryDictionary[cell.value]?.transactionCount + (countryDictionary[cell.value]?.transactionCount > 1 ? ' Transactions' : ' Transaction') : ''}}"
                            >
                              <i class="far fa-random m-r-5"></i>
                              <span>{{countryDictionary[cell.value]?.transactionCount}}</span>
                            </div>
                          </div>
                        </div>
                      </mat-select-trigger>
                      <mat-option *ngFor="let option of cell.options" [value]="option">
                        <div class="flex flex-row justify-between items-center">
                          {{option}}
                          <div class="flex flex-row justify-start items-center">
                            <div
                              *ngIf="countryDictionary[option]?.actualCount>0 || countryDictionary[option]?.proposedCount>0"
                              class="actual-enitiy m-r-15 flex flex-row justify-start items-center"
                              matTooltip="{{countryDictionary[option]?.actualCount > 0 ? countryDictionary[option]?.actualCount + (countryDictionary[option]?.actualCount > 1 ? ' Actual Entities' : ' Actual Entity') : ''}} {{countryDictionary[option]?.actualCount>0 && countryDictionary[option]?.proposedCount>0 ? '& ' : ''}}{{countryDictionary[option]?.proposedCount > 0 ? countryDictionary[option]?.proposedCount + (countryDictionary[option]?.proposedCount > 1 ? ' Proposed Entities' : ' Proposed Entity') : ''}}">
                              <i class="far fa-stop m-r-5"></i>
                              <span>{{countryDictionary[option]?.actualCount + countryDictionary[option]?.proposedCount}}</span>
                            </div>
                            <div
                              *ngIf="countryDictionary[option]?.transactionCount>0"
                              class="actual-enitiy m-r-15 flex flex-row justify-start items-center"
                              matTooltip="{{countryDictionary[option]?.transactionCount > 0 ? countryDictionary[option]?.transactionCount + (countryDictionary[option]?.transactionCount > 1 ? ' Transactions' : ' Transaction') : ''}}"
                            >
                              <i class="far fa-random m-r-5"></i>
                              <span>{{countryDictionary[option]?.transactionCount}}</span>
                            </div>
                          </div>
                        </div>
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline" *ngIf="cell.style === 'InputDateCell'">
                    <mat-label>Choose a date</mat-label>
                    <input matInput [value]="parseDate(cell.value)" [matDatepicker]="picker"
                           (dateChange)="onDateChange($event, cell)">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                  <mat-form-field class="w-p-100" appearance="outline"
                                  *ngIf="cell.style === 'InputNumberCell' || cell.style === 'InputPercentageCell' || cell.style === 'InputTextCell'">
                    <input matInput [(ngModel)]="cell.value" (ngModelChange)="onFormValueChange($event, cell)"
                           (blur)="refreshMemo()">
                  </mat-form-field>
                  <div class="flex flex-row justify-between items-center" *ngIf="isOnlyShowData(cell.style)">
                    {{cell.value}}
                    <span *ngIf="cell.link!='' && !forceHide(memoInfo?.spreadsheet?.templateName)">
                    <a class="link-color" (click)='goTo(cell.link)'>{{cell.displayText}}</a>
                  </span>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav-container>
  <!--<div fxLayout="row" fxLayoutAlign="space-between center" class="form-footer">
    <span>Click the button opposite to see the memo. You can export the memo to Word and modify the content.</span>
    <button mat-flat-button class="orbitax-footer-action-button" type="button" color="accent" (click)="viewMemo()">View
      Memo
    </button>
  </div>-->
</div>
